var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('a',{staticClass:"iubenda-white no-brand iubenda-embed iub-body-embed",attrs:{"href":"https://www.iubenda.com/terms-and-conditions/79904406","title":"Terms and Conditions"}},[_vm._v(" Terms and Conditions ")])])}
var staticRenderFns = []

export { render, staticRenderFns }